import { render } from "./RiJump.vue?vue&type=template&id=2b3a387b"
import script from "./RiJump.vue?vue&type=script&lang=js"
export * from "./RiJump.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/sc/display/scIcon/iconDist/RiJump.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2b3a387b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2b3a387b', __exports__)) {
    api.reload('2b3a387b', __exports__)
  }
  
  module.hot.accept("./RiJump.vue?vue&type=template&id=2b3a387b", () => {
    api.rerender('2b3a387b', render)
  })

}


export default __exports__